var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['web-004-page', _vm.isMobile && 'mobile-page']},[(_vm.cp_carouselImages.length)?_c('carousel',{attrs:{"list":_vm.cp_carouselImages}}):_vm._e(),(!_vm.isMobile)?_c('contentList'):_c('contentList_mobile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }